import { DecoratorNode, type LexicalNode, type SerializedLexicalNode } from "lexical";
import type { Component } from "vue";
import { h } from "vue";

import { EntityName } from "~/shared/enums";

import DartLink from "./DartLink.vue";

export type SerializedSkillChipNode = SerializedLexicalNode & { skillDuid: string; label: string };

export class SkillChipNode extends DecoratorNode<Component> {
  __skillDuid: string;

  __label: string;

  static getType(): string {
    return "skill-chip";
  }

  static clone(node: SkillChipNode): SkillChipNode {
    return new SkillChipNode(node.__skillDuid, node.__label, node.__key);
  }

  constructor(skillDuid: string, label: string, key?: string) {
    super(key);
    this.__skillDuid = skillDuid;
    this.__label = label;
  }

  getSkillDuid(): string {
    return this.__skillDuid;
  }

  getLabel(): string {
    return this.__label;
  }

  // eslint-disable-next-line class-methods-use-this
  createDOM(): HTMLElement {
    return document.createElement("span");
  }

  // eslint-disable-next-line class-methods-use-this
  updateDOM(): false {
    return false;
  }

  static importJSON(serializedNode: SerializedSkillChipNode): LexicalNode {
    return new SkillChipNode(serializedNode.skillDuid, serializedNode.label);
  }

  exportJSON(): SerializedSkillChipNode {
    return {
      type: SkillChipNode.getType(),
      skillDuid: this.getSkillDuid(),
      label: this.getLabel(),
      version: 1,
    };
  }

  decorate(): Component {
    return h(DartLink, {
      name: EntityName.SKILL,
      duid: this.getSkillDuid(),
    });
  }

  // eslint-disable-next-line class-methods-use-this
  isInline(): true {
    return true;
  }

  // eslint-disable-next-line class-methods-use-this
  isKeyboardSelectable(): false {
    return false;
  }

  getTextContent(): string {
    return `[Skill: ${this.getLabel()}]`;
  }
}

export const $createSkillChipNode = (skillDuid: string, label: string): SkillChipNode =>
  new SkillChipNode(skillDuid, label);
